var CardAnswer = function () {

	this.getCookie = function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i < ca.length; i++) {
		  var c = ca[i];
		  while (c.charAt(0) == ' ') {
			c = c.substring(1);
		  }
		  if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		  }
		}
		return "";
	}
	
	this.setCookie = function(cname, cvalue, exdays) {
		var cookie = this.getCookie(cname);
		
		if(cookie != ''){
			cvalue = cookie + ',' + cvalue;
		}
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

    this.init = function () {
		var initial = this;

		var component = $('[data-component="card-answer"]');
		var idComponent = component.data('id');
		var card = $('#cardAssistentShow').val();

		if(card == 'true'){
			component.show();
		}

		var ordAtual = 1;
		$('.question-block').hide();
		$('.question-block[data-ord="'+ ordAtual +'"]').show();

		$('[data-component="card-answer"] .close-modal').click(function(){
			component.hide();
		});
		
		$('[data-component="card-answer"] button').click(function(){
			var obj = $(this);
			var bloco = obj.parent('.question-block');
			var idAsk = bloco.data('id');
			var question = '';
			var tipo = '';

			if(obj.hasClass('btn-send')){
				question = bloco.find('.textarea-question').val();
				tipo = '2';
			}else{
				question = obj.text();
				tipo = '1';
			}
			
			var answerData = {
				"IDQuestion": idAsk, 
				"Tipo": tipo, 
				"Description": question
			}

			$.ajax({
				type: "POST",
				url: "/umbraco/surface/cardquestion/submitanswer",
				data: JSON.stringify({"ComponentID" : idComponent, "cardquestionanswer": answerData }),
				dataType: "json",
				async: true,
				contentType: "application/json; charset=utf-8",
				success: function success(response) {

					if(response == true){

						initial.setCookie('d13a57588bd1492160bcd425a99812b2', idAsk, 1000);

						$('.question-block[data-ord="'+ ordAtual +'"]').hide();
						ordAtual++;
						if($('.question-block[data-ord="'+ ordAtual +'"]').length > 0){
							$('.question-block[data-ord="'+ ordAtual +'"]').show();
						}else{
							component.hide();	
						}
						
					}
					else{
					
					}

				},
				error: function error(e) {
					
				},
				complete: function () {
					
				}
			});
		});
	}
    return this.init();
}